import validate from 'validate';
// https://github.com/cferdinandi/validate/blob/master/package.json
// import and run validate.init();

const defaultConfig = {
  // Classes and Selectors
  selector: '[data-validate]', // The selector for forms to validate
  fieldClass: 'has-error', // The class to apply to fields with errors
  errorClass: 'help-block', // The class to apply to error messages

  // Messages
  messageValueMissing: 'Campo obrigatório.', // Displayed when a required field is left empty
  messageValueMissingSelect: 'Selecione uma opção.',
  messageTypeMismatchEmail: 'Digite um e-mail válido.', // Displayed when a `type="email"` field isn't a valid email
  messageTypeMismatchURL: 'Insira uma URL válida.', // Displayed when a `type="url"` field isn't a valid URL
  messageTooShort: 'Deve ter {minLength} caracteres ou mais.', // Displayed with the `minLength` attribute is used and the input value is too short
  messageTooLong: 'Deve ter {maxLength} caracters ou menos. Você está usando {length} caracteres.', // Displayed with the `maxLength` attribute is used and the input value is too long
  messagePatternMismatch: 'Formato inválido.', // Displayed with the `pattern` attribute is used and the pattern doesn't match (if a `title` attribute is used, that's displayed instead)
  messageBadInput: 'Insira apenas números.', // Displayed when the field is numeric (ex. `type="number"`) but the value is not a number
  messageStepMismatch: 'Selecione um valor válido.', // Displayed when the `step` attribute is used and the value doesn't adhere to it
  messageRangeOverflow: 'Selecione um valor acima de {max}.', // Displayed with the `max` attribute is used and the input value is too hight
  messageRangeUnderflow: 'Selecione um valor abaixo de {min}.', // Displayed with the `mind` attribute is used and the input value is too low
  messageGeneric: 'Valor inválido.', // A catchall error, displayed when the field fails validation and none of the other conditions apply

  // Custom
  createFeedbackIcon(className) {
    let node = document.createElement('i');
    node.classList.add('form-control-feedback', 'js-form-control-feedback', 'q-icon', `q-icon-${className}`);
    return node;
  },

  // Form Submission
  disableSubmit: false,

  customValidity: {
    badConfirm: {
      check(field) {
        if (!field.hasAttribute('confirm')) return false;
        const value = field.value;
        const fieldToCompare = field.getAttribute('confirm');
        const fieldToCompareValue = field.form.querySelector(`#${fieldToCompare}`).value;

        return value !== fieldToCompareValue;
      },
      message: 'O valor não é igual.'
    }
  },
  // onSubmit() {},

  // Callbacks
  beforeShowError(field) {
    const parent = field.parentNode;

    if (parent.classList.contains('form-group') || parent.classList.contains('input-group')) {
      const formControl = parent.querySelector('.js-form-control-feedback');
      parent.classList.remove('has-success', 'has-error', 'has-warning');
      parent.classList.add('has-error', 'has-feedback');
      if (formControl) formControl.remove();
      parent.appendChild(this.createFeedbackIcon('times-circle'));
    }
  },

  // afterShowError(field, error) {}
  beforeRemoveError(field) {
    const parent = field.parentNode;
    
    if (parent.classList.contains('form-group') || parent.classList.contains('input-group')) {
      const formControl = parent.querySelector('.js-form-control-feedback');
      parent.classList.remove('has-success', 'has-error', 'has-warning');
      parent.classList.add('has-feedback', 'has-success');
      if (formControl) formControl.remove();
      parent.appendChild(this.createFeedbackIcon('check-circle'));
    }
  }

  // afterRemoveError(input) {}

};

const validator = {
  config: defaultConfig,
  validate,
  init(config = null) {
    const expandedConfig = {...defaultConfig, ...config};
    validate.init(expandedConfig);
  }
};

export default validator;
